export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-beautiful-dnd/~/@babel/runtime/helpers/esm/inheritsLoose.js
// module id = NAt+
// module chunks = 0